import moment from 'moment'

export const LARGE_TENANT_YARD_THRESHOLD = 15
export const LARGE_FLEET_MAX_DATE_RANGE_DAYS = 7

export function configureTenantBaseOptions(baseOptions) {
  const base_options = (baseOptions || []).map(opt => ({ ...opt }))
  const yardCount = Math.max(0, base_options.length - 1)
  const base_required = yardCount > LARGE_TENANT_YARD_THRESHOLD
  if (base_required && base_options.length > 0)
    base_options[0] = { ...base_options[0], value: '', text: 'Select Base' }
  return { base_required, base_options }
}

export function awaitingBaseSelection(baseRequired, selectedBase) {
  return baseRequired && !selectedBase
}

export function getDateRangeSpanDays(fromDate, toDate) {
  return moment(toDate, 'MM-DD-YYYY').diff(moment(fromDate, 'MM-DD-YYYY'), 'days')
}

export function isDateRangeExceedingLargeFleetLimit(fromDate, toDate, baseRequired, maxDays = LARGE_FLEET_MAX_DATE_RANGE_DAYS) {
  if (!baseRequired)
    return false
  return getDateRangeSpanDays(fromDate, toDate) >= maxDays
}

export function clampDateRangeForLargeFleet(fromDate, toDate, changedField, maxDays = LARGE_FLEET_MAX_DATE_RANGE_DAYS) {
  const maxSpan = maxDays - 1
  const from = moment(fromDate, 'MM-DD-YYYY')
  const to = moment(toDate, 'MM-DD-YYYY')
  if (from.isAfter(to, 'day')) {
    if (changedField === 'to')
      return { fromDate: toDate, toDate }
    return { fromDate, toDate: fromDate }
  }
  if (to.diff(from, 'days') <= maxSpan)
    return { fromDate, toDate }
  if (changedField === 'from')
    return { fromDate, toDate: from.clone().add(maxSpan, 'days').format('MM-DD-YYYY') }
  return { fromDate: to.clone().subtract(maxSpan, 'days').format('MM-DD-YYYY'), toDate }
}
